import Axios from 'axios';

export default {

  // 列表
  list() {
    return Axios.get('/base/api/admin/all-menu');
  },

  // 添加
  add(
    parent_id,
    level,
    type,
    title,
    name,
    path,
    icon,
    component,
    button_type,
    url,
    http_method,
    sort_order,
    is_overall,
    status
  ) {
    return Axios.post('/base/api/admin/permission', {
      parent_id,
      level,
      type,
      title,
      name,
      path,
      icon,
      component,
      button_type,
      url,
      http_method,
      sort_order,
      is_overall,
      status
    });
  },

  // 修改
  edit(
    id,
    parent_id,
    level,
    type,
    title,
    name,
    path,
    icon,
    component,
    button_type,
    url,
    http_method,
    sort_order,
    is_overall,
    status
  ) {
    return Axios.patch(`/base/api/admin/permission/${id}`, {
      parent_id,
      level,
      type,
      title,
      name,
      path,
      icon,
      component,
      button_type,
      url,
      http_method,
      sort_order,
      is_overall,
      status
    });
  },

  // 批量删除
  batchDel(
    ids
  ) {
    return Axios.delete('/base/api/admin/permission/delete', {
      data: {
        ids
      }
    });
  }

}